import { useDivisionListQuery } from '../queries';
import { ForwardedRef, forwardRef, useMemo, useState } from 'react';
import { Input, SearchSelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';

type Props<TFormState extends BaseFormState> = Omit<
  SearchSelectProps<TFormState>,
  'options' | 'search' | 'setSearch' | 'isLoading'
>;

function DivisionSearchSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLInputElement>
) {
  const [search, setSearch] = useState<string>('');

  const { data, isLoading } = useDivisionListQuery(
    {
      page_size: 100,
      search,
    },
    search.length > 3
  );

  const options = useMemo<[string, number][]>(() => {
    return data?.results.map(({ id, name, series }) => [`${series.name} - ${name}`, id]) ?? [];
  }, [data]);

  return (
    <Input.SearchSelect
      setSearch={setSearch}
      isLoading={isLoading}
      options={options}
      search={search}
      ref={ref}
      {...props}
    />
  );
}

export const DivisionSearchSelect = forwardRef(DivisionSearchSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLInputElement> }
) => ReturnType<typeof DivisionSearchSelectElement>;
